module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add stickers-pic1.dde6f2c4.jpg";